import {useProductContext} from 'contexts/ProductContext';
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import styled from 'styled-components';

export const useItemColumn = (loader: boolean) => {
    const observer = useRef<ResizeObserver>();
    const observed = useRef<HTMLElement>();
    const {isMiniBrowser} = useProductContext();

    const [containerLength, setContainerLength] = useState<number | undefined>(
        isMiniBrowser ? 310 : undefined
    );

    const resizeHandler = useCallback(() => {
        if (observed.current) {
            const dimension = observed.current.getBoundingClientRect();
            setContainerLength(dimension.width);
        }
    }, []);

    const resizeRef = useCallback((container: HTMLElement) => {
        if (container) {
            observed.current = container;
            observer.current = new ResizeObserver(resizeHandler);

            observer.current.observe(container);
        }
    }, []);

    const loaders = useMemo(() => {
        if (loader) {
            return (
                <>
                    <ItemColumn $container={containerLength}>
                        <div className="hardwareItem">
                            <AnimatedBackground
                                $isMiniBrowser={isMiniBrowser ?? false}
                                className="animated-background"
                            />
                        </div>
                    </ItemColumn>
                    <ItemColumn $container={containerLength}>
                        <div className="hardwareItem">
                            <AnimatedBackground
                                $isMiniBrowser={isMiniBrowser ?? false}
                                className="animated-background"
                            />
                        </div>
                    </ItemColumn>
                    <ItemColumn $container={containerLength}>
                        <div className="hardwareItem">
                            <AnimatedBackground
                                $isMiniBrowser={isMiniBrowser ?? false}
                                className="animated-background"
                            />
                        </div>
                    </ItemColumn>
                </>
            );
        }
    }, [loader]);

    useEffect(() => {
        return () => {
            if (
                observer.current != undefined &&
                observed.current instanceof HTMLElement
            ) {
                observer.current.unobserve(observed.current);
            }
        };
    }, []);

    return {
        loaders,
        containerLength,
        resizeRef,
    };
};

export const ItemColumn = styled.div<{
    $hardware?: boolean;
    $container?: number;
}>`
    .details {
        // height: ${({$hardware}) => ($hardware ? '170px' : '135px')};
    }
`;

const AnimatedBackground = styled.div<{$isMiniBrowser: boolean}>`
    ${({$isMiniBrowser}) => {
        if ($isMiniBrowser) {
            return 'width: inherit !important;';
        }
    }}
`;
